import { useIntl } from '@capsicum/common';
import { CondensedButton } from '@capsicum/common-web';
import { type FTOBuyButtonProps, FTOCardStatus } from '@capsicum/features/fan-token-offering/shared';

import * as S from '../FanTokenOffering.styled';

/**
 * Display a Buy button with the quantity of fan token the user can buy
 *
 * @param {quantityAvailable} props.quantityAvailable amount if fan token the user can buy
 * @param {partnerId} props.partnerId Id of the campaign's partner
 * @returns {JSX.Element} a with a button and some comments
 */
export const FTOBuyButton = ({
	onBuyClick,
	partnerId,
	quantityAvailable,
	shortCode,
	status,
	testID
}: FTOBuyButtonProps) => {
	const { $t } = useIntl();

	const onBuy = (e: React.MouseEvent) => {
		e.stopPropagation();
		onBuyClick();
	};

	return (
		<S.BuyContainer onClick={e => e.stopPropagation()}>
			{quantityAvailable && (
				<S.Comment>
					{$t('fanTokenOffering.quantityAvailable', {
						amount: quantityAvailable,
						partnerShortCode: shortCode
					})}
				</S.Comment>
			)}
			{status !== FTOCardStatus.PUBLISHED && (
				<CondensedButton
					color="brand"
					debouncingTime={500}
					disabled={status !== FTOCardStatus.OPENED}
					size="xsmall"
					testID={`${testID}-ftoBuyButtonPartnerId:${partnerId}-button`}
					text={`${$t('fanTokenOffering.buyButton', { shortCode })}`}
					textSize="xsmall"
					onClick={onBuy}
				/>
			)}
		</S.BuyContainer>
	);
};
